export const OfficeAccessoriesListState = {
	url: '/accessories',
	title: 'Office Accessories List',
	template: '<office-accessories-list-page></office-accessories-list-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAccessoriesPageMod" */
			'@Containers/office-accessories-page/office-accessories-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
